// webapp/src/lib/offlineDrain.js
//
// Single home for the offline write-queue drain wiring (per-type store
// callbacks + user-facing toasts) so app boot, 'online' events and manual
// retries all behave identically. Stores are lazy-required so importing
// this module never drags the store graph in at module-eval time.

import * as offlineWriteQueue from './offlineWriteQueue';
import * as ipscScoreQueue from './ipscScoreQueue';

export function drainQueues() {
    /* eslint-disable global-require */
    const appState = require('../stores/appState').default;
    const saleStore = require('../stores/sale').default;
    const animalStore = require('../stores/animal').default;
    const journalStore = require('../stores/journal').default;
    const articleStore = require('../stores/article').default;
    /* eslint-enable global-require */
    return offlineWriteQueue.drain({
        onReplaced: (type, tempId, realId, response) => {
            if (type === 'sale') {
                saleStore.replaceSaleId(tempId, realId, response);
            }
            if (type === 'article') {
                const realArticle = response && response.data && response.data.article;
                articleStore.replacePendingArticle(tempId, realArticle || { id: realId });
            }
            // Every resolved temp id has to be swapped out of the state the user
            // is still holding, whatever its type. The old assumption here was
            // that drain's rewrite pass already handled every dependent — it only
            // handles entries that are IN the queue. A record the user creates or
            // saves ONLINE after this drain (the normal "create customer, then add
            // the animal" flow) never goes through that pass, and used to be
            // persisted carrying the negative temp id: the sale then had an owner
            // that could not be resolved and could not be transferred to Fiken.
            // Temp ids are unique negative numbers, so this is safe to run for
            // every type.
            saleStore.replaceOfflineTempId(tempId, realId);
            animalStore.replaceOfflineTempId(tempId, realId);
            journalStore.replaceOfflineTempId(tempId, realId);
        },
        onFailed: (type, entry) => {
            if (type === 'article') {
                articleStore.markPendingArticleFailed(entry.tempId, entry.lastError);
                appState.addToast('Innlegget kunne ikke publiseres. Se innlegget i strømmen for å prøve igjen.', 8000);
                return;
            }
            if (type === 'sale') {
                saleStore.markSaleSyncFailed(entry.tempId, entry.lastError);
            }
            appState.addToast(
                type === 'sale'
                    ? 'Salg kunne ikke synkroniseres. Åpne "Ventende salg" for detaljer.'
                    : `${type} kunne ikke synkroniseres. Åpne "Ventende salg" for detaljer.`,
                8000,
            );
        },
    }).then((counters) => {
        try { saleStore.loadPendingSales(); } catch (e) { /* ignore */ }
        // IPSC scoresheets left on a phone drain here too, not only while the RO
        // page is mounted (its own interval drains while open).
        ipscScoreQueue.drain().catch(() => {});
        return counters;
    });
}
